import $ from 'jquery';
import Modal from '../libs/Modal';
import Ajax from '../Ajax';

export default {
    methods: {
        ctaFavorite() {
            if (!window.GrandsEspaces.user) {
                // not logged
                this.$root.$refs['login-panel'].iswishlist = true;

                Modal.showModal('#loginpanel');
                return null;
            }

            if (this.isFavorite) {
                this.removeFromFavorite();
            } else {
                this.addToFavorite();
            }
        },
        addToFavorite() {
            // TODO refactor to use ajaxForm mixin
            Ajax.post(window.GrandsEspaces.adminUrl, {
                    action: 'ge_add_cruise_to_wishlist',
                    cruise_id: this.cruise.ID,
                }, {
                    xhrFields: {
                        withCredentials: true,
                    },
                })
                .then(() => this.isFavorite = true);
        },
        removeFromFavorite() {
            // TODO refactor to use ajaxForm mixin
            Ajax.post(window.GrandsEspaces.adminUrl, {
                    action: 'ge_remove_cruise_to_wishlist',
                    cruise_id: this.cruise.ID,
                }, {
                    xhrFields: {
                        withCredentials: true,
                    },
                })
                .then(() => {
                    this.isFavorite = false;

                    if ($('body').hasClass('woocommerce-account')) {
                        $(this.$el).fadeOut(400);
                    }
                });
        },
    },
};


// WEBPACK FOOTER //
// ./assets/js/mixins/addToWishList.js